// Design tokens + helpers for the CRM Kanban redesign (3 variants).
// Fonte da verdade: design_handoff_crm_kanban/README.md + CRM Kanban.dc.html.
// Sem dependências externas — tudo client-side.

// Tags (chip): [textColor, bgColor]
export const TAGS = {
  Franquia: ["#C2410C", "#FFEDD5"],
  Orçamento: ["#1D4ED8", "#DBEAFE"],
  Revenda: ["#7C3AED", "#EDE9FE"],
  Dúvida: ["#52606D", "#E4E7EB"],
  Parceria: ["#BE185D", "#FCE7F3"],
  Projeto: ["#0F766E", "#CCFBF1"],
};

export const TAG_KEYS = Object.keys(TAGS);

// Canais: key -> [label, dotColor]
export const CH = {
  whatsapp: ["WhatsApp", "#22C05C"],
  instagram: ["Instagram", "#E1306C"],
  site: ["Site", "#4A6CF7"],
};

export const CH_KEYS = Object.keys(CH);

// Prioridade: key -> [label, textColor, bgColor]
export const PRIO = {
  alta: ["Alta", "#E5484D", "#FDE8E8"],
  media: ["Média", "#B7791F", "#FFF3DC"],
  baixa: ["Baixa", "#5B6472", "#EEF1F4"],
};

export const PRIO_KEYS = Object.keys(PRIO);

// Estados de SLA: [bg, text, bar]
export const SLA = {
  ok: ["#EEF1F4", "#5B6472", "#9AA3AF"],
  warn: ["#FFF3DC", "#B7791F", "#F5A623"],
  late: ["#FDE8E8", "#C0392B", "#E5484D"],
};

// Paleta determinística de atendentes (cores do design + extras).
export const ATTENDANT_PALETTE = [
  "#E85D9E",
  "#3E7BFA",
  "#8B5CF6",
  "#14B8A6",
  "#F2653A",
  "#27AE60",
  "#9B51E0",
  "#2E90FA",
  "#B7791F",
  "#E5484D",
];

// Fontes por variante.
export const VARIANT_FONT = {
  sunlit: "Nunito, sans-serif",
  funnel: "Outfit, sans-serif",
  soft: "'Plus Jakarta Sans', sans-serif",
};

// R$ 18.400
export const fmtBRL = (n) => "R$ " + Number(n || 0).toLocaleString("pt-BR");

// Timer: <60min -> "42min"; <24h -> "1h50" / "3h"; >=24h -> "1d 2h"
export const fmtTimer = (mins) => {
  let m = Math.round(Number(mins) || 0);
  if (m < 0) m = 0;
  if (m < 60) return m + "min";
  if (m < 1440) {
    const h = Math.floor(m / 60);
    const r = m % 60;
    return r ? h + "h" + String(r).padStart(2, "0") : h + "h";
  }
  return Math.floor(m / 1440) + "d " + Math.floor((m % 1440) / 60) + "h";
};

// Estado do SLA a partir dos minutos. Stage não-open (isOpen=false) -> neutro.
export const slaState = (mins, limit, isOpen) => {
  if (!isOpen) return "ok";
  const lim = Number(limit) || 60;
  if (mins >= lim * 2) return "late";
  if (mins >= lim) return "warn";
  return "ok";
};

// Minutos desde o último contato (lastContactAt ISO ou null -> 0).
export const minsFromLastContact = (lastContactAt) => {
  if (!lastContactAt) return 0;
  const t = new Date(lastContactAt).getTime();
  if (Number.isNaN(t)) return 0;
  return Math.max(0, (Date.now() - t) / 60000);
};

// Clareia uma cor hex ~90% (mix com branco) — usado p/ tint das lanes (1b).
export const tintFromColor = (hex, amount = 0.9) => {
  const c = (hex || "#64748B").replace("#", "");
  if (c.length !== 6) return "#F1F4F8";
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const mix = (v) => Math.round(v + (255 - v) * amount);
  const toHex = (v) => v.toString(16).padStart(2, "0");
  return "#" + toHex(mix(r)) + toHex(mix(g)) + toHex(mix(b));
};

// Hash simples determinístico a partir do nome.
const hashStr = (str) => {
  let h = 0;
  const s = String(str || "");
  for (let i = 0; i < s.length; i += 1) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
};

// Cor determinística do atendente a partir do nome.
export const attendantColor = (name) => {
  if (!name) return ATTENDANT_PALETTE[0];
  return ATTENDANT_PALETTE[hashStr(name) % ATTENDANT_PALETTE.length];
};

// Iniciais: nome+sobrenome, ou 2 primeiras letras.
export const initials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length > 1) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return parts[0].slice(0, 2).toUpperCase();
};
